import { render, staticRenderFns } from "./CaraKerja.vue?vue&type=template&id=48a8dece&scoped=true"
import script from "./CaraKerja.vue?vue&type=script&lang=js"
export * from "./CaraKerja.vue?vue&type=script&lang=js"
import style0 from "./CaraKerja.vue?vue&type=style&index=0&id=48a8dece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48a8dece",
  null
  
)

export default component.exports